<template>
    <svg
        id="Download"
        xmlns="http://www.w3.org/2000/svg"
        width="26.5"
        height="17.805"
        viewBox="0 0 26.5 17.805"
    >
        <path
            id="Pfad_397"
            data-name="Pfad 397"
            d="M13.25,40.006a.75.75,0,0,1-.75-.75V35.2a.75.75,0,0,1,1.5,0v4.052a.75.75,0,0,1-.75.75"
            transform="translate(0 -28)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_398"
            data-name="Pfad 398"
            d="M9.9,38.256l6.69-.005a.5.5,0,0,1,.355.855l-3.341,3.347a.5.5,0,0,1-.709,0L9.55,39.112a.5.5,0,0,1,.354-.856"
            transform="translate(0 -28)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_399"
            data-name="Pfad 399"
            d="M20.858,45.805H6.728a6.727,6.727,0,0,1-.814-13.4A7.9,7.9,0,0,1,13.25,28c4.23,0,7.687,2.909,7.812,6.525a5.642,5.642,0,0,1-.2,11.28M13.25,29.5c-2.833,0-5.338,1.582-6.093,3.846a.75.75,0,0,1-.678.512,5.226,5.226,0,0,0,.249,10.447h14.13a4.142,4.142,0,1,0,0-8.283,4.331,4.331,0,0,0-.489.027.749.749,0,0,1-.831-.834,4.265,4.265,0,0,0,.027-.486c0-2.883-2.833-5.229-6.315-5.229"
            transform="translate(0 -28)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "DownloadIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
